import React, { FC } from "react";
import { Image } from "../../types";
import RightArrow from "../../assets/images/carousel_right_arrow.svg";
import {
  Arrow,
  BottomLink,
  Container,
  Content,
  Date,
  Picture,
  Title,
  Type,
} from "./styles";

export type AnimatedCardProps = {
  image: Image;
  link: string;
  readMore: string;
  type?: string;
  date?: string;
  title?: string;
  description?: string;
  typeColor: string;
};

const AnimatedCard: FC<AnimatedCardProps> = ({
  image,
  link,
  readMore,
  type,
  date,
  title,
  typeColor,
  description,
}: AnimatedCardProps) => {
  return (
    <Container className="ignore" to={link}>
      <Picture src={image?.src} alt={image?.alt} />
      <Content>
        <Type className="font-gt-alpina" color={typeColor}>{type}</Type>
        <Date className="font-gt-alpina">{date}</Date>
        <Title className="font-gt-alpina">{title}</Title>
        <BottomLink>
          {readMore}
          <Arrow src={RightArrow} />
        </BottomLink>
      </Content>
      {description && (
        <Content>
          <Type className="font-gt-alpina" color={typeColor}>{type}</Type>
          <Date className="font-gt-alpina">{date}</Date>
          <Title className="font-gt-alpina">{description}</Title>
          <BottomLink>
            {readMore}
            <Arrow src={RightArrow} />
          </BottomLink>
        </Content>
      )}
    </Container>
  );
};

export default AnimatedCard;
